<template>
  <div class="row">
    <div class="col-sm-4" v-if="with_prefix">
      <h4>{{ '#' + attribute_type.id }} {{ attribute_type.key | t }}</h4>
    </div>
    <div v-bind:class="{ 'col-sm-8': with_prefix, 'col-sm-12': !with_prefix }">
      <webshipper-input-string
        v-model="attribute_type.key"
        :readonly="readonly_key"
        :label="'key'"
      ></webshipper-input-string>
      <webshipper-input-string v-model="attribute_type.value" :label="'value'"></webshipper-input-string>
      <webshipper-input-string v-model="attribute_type.description" :label="'description'"></webshipper-input-string>
      <webshipper-input-string
        :value="attribute_type.avaliable_liquids.join(',')"
        @input="(a) => (attribute_type.avaliable_liquids = a.split(','))"
        :help_text="'Commaseperated list. E.g (email,phone,name)'"
        :label="'placeholders'"
      ></webshipper-input-string>
      <div class="row">
        <div class="col">
          <webshipper-input-radio
            v-model="attribute_type.required"
            :label="'required'"
            :has_revert="false"
          ></webshipper-input-radio>
        </div>
        <div class="col">
          <webshipper-input-radio
            v-model="attribute_type.visible"
            :label="'visible'"
            :has_revert="false"
          ></webshipper-input-radio>
        </div>
        <div class="col-12">
          <webshipper-input-radio-seperated
            v-model="attribute_type.input_type"
            :options="input_type_options"
            :label="'input_type'"
          ></webshipper-input-radio-seperated>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12">
          <mail-builders-module-locale
            class="mb-5"
            v-for="locale_type in attribute_type.locale_types"
            :key="locale_type.id"
            :locale_type="locale_type"
            :attribute_type="attribute_type"
          ></mail-builders-module-locale>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ts-check
import _ from 'lodash';

export default {
  props: {
    attribute_type: {
      type: Object,
      required: true
    },
    active_locales: {
      type: Array,
      required: true
    },
    with_prefix: {
      type: Boolean,
      required: false,
      default: true
    },
    readonly_key: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      input_type_options: ['string', 'text', 'boolean']
    };
  },
  watch: {
    active_locales: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.populate_locale_types();

        if (oldValue && oldValue.length > newValue.length) {
          this.unpopulate_locale_types(oldValue.filter((x) => !newValue.includes(x)));
        }
      }
    }
  },
  methods: {
    /**
     * Create input fields for all active languages. English ('en') is excluded as its default
     * When saving template_type, any added but empty locale_types is purged
     */
    populate_locale_types() {
      _.without(this.active_locales, 'en').forEach((active_locale) => {
        const found_locale_type = this.attribute_type.locale_types.find((x) => x.locale === active_locale);
        if (found_locale_type) {
          return;
        }

        this.attribute_type.locale_types.push({
          value: null,
          key: null,
          description: null,
          locale: active_locale,
          attribute_type_id: this.attribute_type.id
        });
      });
    },
    /**
     * Removes locale_types for language which has been removed from ative_locales
     */
    unpopulate_locale_types(removed_locales) {
      this.attribute_type.locale_types = _.remove(
        this.attribute_type.locale_types,
        (x) => x.locale !== removed_locales[0]
      );
    }
  }
};
</script>
